import React, { useState, useEffect } from 'react';
import { get, post } from '../helper/httpClient';
import { endPoints } from '../constants/endPoints';
import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";
import moment from 'moment';
import tz from 'moment-timezone';
import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import FilledInput from '@material-ui/core/FilledInput';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import GenericNotFound from '../components/GenericNotFound';
import TextField from '@material-ui/core/TextField';
import { css } from "@emotion/core";
import BeatLoader from "react-spinners/BeatLoader";
import SquareLoader from "react-spinners/SquareLoader";
import ScaleLoader from "react-spinners/ScaleLoader";
import clsx from 'clsx';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ArrowBack from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
        width: '75%',
        alignContent: 'center'
    },
    selectControl: {
        minWidth: '20rem',
        maxWidth: '20rem',
        marginRight: "1rem",
        "& .MuiInputLabel-outlined.MuiInputLabel-shrink" : {
            transform: "translate(14px, -6px) scale(0.72)"
        },
        "& .MuiOutlinedInput-notchedOutline .PrivateNotchedOutline-legendLabelled-10" : {
            fontSize: "0.72rem"
        }
    },
    selectControlSmall: {
        padding: "14px",
        fontSize: "14px"
    },
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '75%',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '1px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: 'gray',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: 'gray',
        },
    },
}));

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple={true}
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}



let timezone = moment.tz.guess();
let timezone_abbr = moment.tz(timezone).zoneAbbr();
// let timezone_abbr = moment().tz(timezone).format('z');
if (timezone == 'Asia/Calcutta') {
    timezone = 'Asia/Kolkata';
}  //debugger
//Daylight Saving ---Normal TimeZone
if (timezone_abbr === 'PDT') {
    timezone_abbr = 'PST';
} else if (timezone_abbr === 'EDT' || timezone === 'America/Bogota' || timezone === 'America/Lima') {
    timezone_abbr = 'EST';
} else if (timezone_abbr === 'CDT') {
    timezone_abbr = 'CST';
} else if (timezone_abbr === 'MDT') {
    timezone_abbr = 'MST';
} else if (timezone_abbr === 'AKDT') {
    timezone_abbr = 'AKST';
} else if (timezone_abbr === 'CEST') {
    timezone_abbr = 'CET';
} else if (timezone_abbr === 'SAST') {
    timezone_abbr = 'CAT';
} else if (timezone_abbr === 'AEST' || timezone_abbr === 'AEDT') {
    timezone_abbr = 'Australia/Queensland';
} else if (timezone_abbr === 'ACST' || timezone_abbr === 'ACDT') {
    timezone_abbr = 'ACT';
} else if (timezone_abbr === 'BST') {
    timezone_abbr = 'Europe/London';
} else if (timezone_abbr === 'AWST' || timezone_abbr === 'AWDT') {
    timezone_abbr = 'Australia/Perth';
} else if (timezone_abbr === 'AST' || timezone_abbr === 'ADT') {
    timezone_abbr = 'Atlantic/Bermuda';
}

let dt = new Date();
let dateString = dt.getFullYear() + "/" + (dt.getMonth() + 1) + "/" + dt.getDate()
let selectedDateMoment = moment(dateString);
let selectedDay = selectedDateMoment.day();

let projectId = null;
let userId = null;
let isCompanyScheduler = false;
let userFname = null;
let userLname = null;


function Scheduler(props) {
  
    let urlPart = props.match.params.scheduler;
    if (!!urlPart && urlPart !== "") {
        urlPart = urlPart.split('-');
        if (Array.isArray(urlPart) && urlPart.length >= 2) {
            projectId = urlPart[0];
            userId = urlPart[1];
            if (urlPart.length > 2) {
                isCompanyScheduler = urlPart[2].toLowerCase() === "company_scheduler";
            }
            // userFname = urlPart[2];
            // userLname = urlPart.slice(3).join('-');
            if (projectId == null || projectId === '' || userId == null || userId === '') {
                window.location.replace("/");
            }

        } else {
            window.location.replace("/");
        }
    } else {
        // window.location.replace("/");
    }
    let initialState = {
        projectId: projectId,
        mounted: false,
        allScheduler: null,
        logo: '',
        selectedScheduler: null,
        selectedSchedulerKey: null,
        scheduler_booked_slots: [],
        selectedDay: null,
        selectedDate: null,
        selectedDateMoment: null,
        selected_date_time: null,
        invalidUrl: false,
        noAppointmentAvailable: false,
        step: 1,
        btnDisabled: false,
        savingForm: false,
        bookingError: false,
        logoLoader: false,
        whiteLabel: true,
        locations: [],
        selectedLocation: '',
        locationError: false,
        selectedAppointmentType: '',
        selectedTechnician: '',
        appointmentTypes: [],
        technicians: [],
        schedulerAvailabilities: [],
        schedulerDetail: {},
        schedulerFields: []
    }
    let [state, setState] = useState(initialState);

    useEffect(() => {
        if (isCompanyScheduler) {
            loadCompanySchedulerData();
        } else {
            loadSchedulerData();
        }
    }, [state.projectId]);

    useEffect(() => {
        updateCompanySchedulerData();
    }, [state.selectedLocation, state.selectedAppointmentType, state.selectedTechnician]);

    let saveSchedulerData = (fields, field_names) => {
        if (!state.savingForm) {


            let selectedScheduler = state.selectedScheduler;
            let params = {
                schedular_id: isCompanyScheduler ? 0 : selectedScheduler.id,
                schedular_name: selectedScheduler.name,
                description: selectedScheduler.description,
                selected_date_time: state.selected_date_time,
                duration: selectedScheduler.duration,
                duration_type: selectedScheduler.durationType,
                project_id: projectId,
                user_id: userId,
                workflow_id: selectedScheduler.workflow_id,
                status_name: selectedScheduler.status_name,
                min_advance_notice: selectedScheduler.min_advance_notice,
                min_advance_notice_type: selectedScheduler.min_advance_notice_type,
                fields: fields,
                filledData: null,
                timezone: timezone_abbr,
                field_names: field_names,
                location: state.selectedLocation,
                appointmentType: state.selectedAppointmentType.eventType,
                isCompanyScheduler: isCompanyScheduler,
                technician_id: state.selectedTechnician.id,
                wf_setup_details:selectedScheduler.wf_setup_details
            }
            setState({ ...state, savingForm: true });
            let promise = Promise.resolve(post(endPoints.SCHEDULER.SAVE, params));
            promise.then((response) => {
                if (response.status == 0 && response.data.isSaved == true) {                let step = 3;
                    if (isCompanyScheduler) {
                        step = 4;
                    }
                    setState({ ...state, step, savingForm: false });
                } else if (response.status == 0 && response.data.isSaved == false && response.data.hasOwnProperty('isTimeSloteBooked') && response.data.isTimeSloteBooked) {
                    updateParentState({ bookingError: true });
                } else if (response.status == -1 || response.data.isSaved == false) {
                    alert("Unable to Save!!");
                }
            });
        }
    }

    function loadSchedulerData(reload = false) {
        let wfSetupDetails;
        let wfSetupDetailsArr = new Array();
        let params = {
            project_id: projectId,
            user_id: userId,
            timezone: timezone_abbr
        }
        try {
            let promise = Promise.resolve(get(endPoints.SCHEDULER.GET, params));
            promise.then((response) => {
                if (response.status === 0) {
                    let data = response.data.appointment_scheduler_info;
                    if (data.scheduler.length > 0) {
                        let allScheduler = {};
                        let selectedScheduler = null;
                        let selectedSchedulerKey = null;
                        data.scheduler.forEach(function (schedulerObj, index) {
                            let key = 'scheduler_' + index;
                           
                           if( schedulerObj.hasOwnProperty('wf_setup_details') && schedulerObj.wf_setup_details !=null){
                            let wfSetupDetails = JSON.parse(schedulerObj.wf_setup_details);
                            let keys = Object.keys(wfSetupDetails);
                            keys.map((key) => {
                                if(wfSetupDetails[key].cWorkflow != null && wfSetupDetails[key].nWorkflow != null )
                                    wfSetupDetailsArr.push(wfSetupDetails[key]);
                            });
                           } 
                            allScheduler[key] = {
                                id: schedulerObj.id,
                                name: schedulerObj.appointment_name,
                                duration: schedulerObj.duration,
                                durationType: schedulerObj.durationType,
                                workflow_id: schedulerObj.workflow_id,
                                status_name: schedulerObj.status_name,
                                availableSlots: schedulerObj.sftr_scheduler_availability,
                                description: schedulerObj.description,
                                location: schedulerObj.location,
                                fields: schedulerObj.sftr_scheduler_fields,
                                thank_you_msg: schedulerObj.thank_you_msg,
                                submit_button_label: schedulerObj.submit_button_label,
                                scheduler_booked_slots: data.scheduler_booked_slots,
                                min_advance_notice: schedulerObj.min_advance_notice,
                                min_advance_notice_type: schedulerObj.min_advance_notice_type,
                                wf_setup_details: wfSetupDetailsArr,

                            }
                            wfSetupDetailsArr = new Array();
                            if (schedulerObj.min_advance_notice_type === 'days') {
                                selectedDateMoment.add(schedulerObj.min_advance_notice, 'days');
                                dt.setDate(dt.getDate() + schedulerObj.min_advance_notice);
                            }
                            let selectedDay = selectedDateMoment.day();

                            allScheduler[key] = {
                                ...allScheduler[key],
                                'selectedDateMoment': selectedDateMoment,
                                'selectedDate': dt,
                                'selectedDay': selectedDay
                            }

                            dt = new Date();
                            dateString = dt.getFullYear() + "/" + (dt.getMonth() + 1) + "/" + dt.getDate()
                            selectedDateMoment = moment(dateString);
                            selectedDay = selectedDateMoment.day();

                            if (index == 0) {
                                selectedScheduler = allScheduler[key];
                                selectedSchedulerKey = key;
                            }
                        });
                        // imp                  

                        let responseData = {
                            'allScheduler': allScheduler,
                            'selectedScheduler': selectedScheduler,
                            'selectedSchedulerKey': selectedSchedulerKey,
                            mounted: true,
                            logo: data.logo_url === undefined ? '/images/soffront_logo.png' : data.logo_url,
                            scheduler_booked_slots: data.scheduler_booked_slots,
                            logoLoader: true,
                        }

                        let whiteLabel = { whiteLabel: data.is_white_label } //*
                        let updatedState = {
                            ...state,
                            ...responseData,
                            ...whiteLabel
                        }
                        if (reload) {
                            updatedState = {
                                ...initialState,
                                ...responseData,
                            }
                        }
                        setState(updatedState);

                    } else {
                        setState({
                            ...state,
                            noAppointmentAvailable: true
                        });
                    }

                } else if (response.status === -1) {
                    // window.location.replace("/");
                    setState({
                        ...state,
                        invalidUrl: true
                    });
                }

            });
        } catch (error) {
            console.log(error);
        }

    }

    const loadCompanySchedulerData = (reload = false) => {
        let params = {
            project_id: projectId,
            user_id: userId,
            timezone: timezone_abbr
        }
        try {
            let promise = Promise.resolve(get(endPoints.COMPANY_SCHEDULER.GET, params));
            promise.then((response) => {
                if (response.status === 0) {
                    let data = response.data;
                    let locations = data.locations;
                    if (locations && locations.length > 0) {
                        let responseData = {
                            mounted: true,
                            logo: data.logoUrl === undefined ? '/images/soffront_logo.png' : data.logoUrl,
                            logoLoader: true,
                            locations: locations,
                            appointmentTypes: data.appointmentTypes,
                            // technicians: data.technicians,
                            // schedulerAvailabilities: data.schedulerAvailabilities,
                            schedulerDetail: data.schedulerDetail,
                            schedulerFields: data.schedulerFields.map(f => ({...f, required: +f.required})),
                        }


                        let whiteLabel = {whiteLabel: data.isWhiteLabel}
                        let updatedState = {
                            ...state,
                            ...responseData,
                            ...whiteLabel,
                        }
                        if (reload) {
                            updatedState = {
                                ...initialState,
                                ...responseData,
                            }
                        }

                        setState(updatedState);
                    } else {
                        setState({
                            ...state,
                            noAppointmentAvailable: true
                        });
                    }
                } else if (response.status === -1) {
                    setState({
                        ...state,
                        invalidUrl: true
                    });
                }

            });
        } catch (error) {
            console.log(error);
        }

    }

    let handleBack = (fields) => {
        let tempStep = 1;
        let tempLocation = state.selectedLocation;
        if (isCompanyScheduler) {
            if (state.step === 3) {
                tempStep = 2;
            }
            if (state.step === 2) {
                tempStep = 1;
                tempLocation = "";
            }
        }
        setState({ ...state, step: tempStep, filledData: fields, selectedLocation: tempLocation });
    }

    let handleLocationChange = (event) => {
        setState({...state, selectedLocation: event.target.value});
    }

    let handleAppointmentTypeChange = (event) => {
        setState({...state, selectedAppointmentType: event.target.value});
    }

    let handleTechnicianChange = (event) => {
        setState({...state, selectedTechnician: event.target.value});
    }

    let onNextClick = () => {
        if (state.selectedLocation && state.selectedLocation !== "") {
            let params = {
                project_id: projectId,
                user_id: userId,
                location: state.selectedLocation
            }
            try {
                let promise = Promise.resolve(get(endPoints.COMPANY_SCHEDULER.GET_TECHNICIANS, params));
                promise.then((response) => {
                    if (response.status === 0) {
                        let data = response.data;
                        let technicians = data.technicians;
                        if (technicians && technicians.length > 0) {
                            const selectedTechnician = technicians[0];
                            const minAdvanceNotice = selectedTechnician.minAdvanceNotice;
                            const minAdvanceNoticeType = selectedTechnician.minAdvanceNoticeType;

                            if (minAdvanceNoticeType === 'days') {
                                selectedDateMoment.add(minAdvanceNotice, 'days');
                                dt.setDate(dt.getDate() + minAdvanceNotice);
                            }
                            let selectedDay = selectedDateMoment.day();

                            const selectedAppointmentType = state.appointmentTypes.length > 0 ? state.appointmentTypes[0] : '';
                            const selectedScheduler = {
                                selectedDateMoment,
                                selectedDate: dt,
                                selectedDay,
                                availableSlots: []
                            }

                            let updatedState = {
                                ...state,
                                technicians,
                                selectedScheduler,
                                step: 2,
                                selectedAppointmentType,
                                selectedTechnician
                            }
                            setState(updatedState);
                        } else {
                            setState({
                                ...state,
                                noAppointmentAvailable: true
                            });
                        }
                    } else if (response.status === -1) {
                        // window.location.replace("/");
                        setState({
                            ...state,
                            invalidUrl: true
                        });
                    }

                });
            } catch (error) {
                console.log(error);
            }
        } else {
            setState({ ...state, locationError: true });
        }
    }
    const updateCompanySchedulerData = () => {
        if (state.selectedTechnician && state.selectedAppointmentType && state.selectedLocation) {
            let params = {
                project_id: projectId,
                user_id: userId,
                timezone: timezone_abbr,
                location: state.selectedLocation,
                appointmentType: state.selectedAppointmentType.eventType,
                technicianId: state.selectedTechnician.id,
            }
            try {
                let promise = Promise.resolve(get(endPoints.COMPANY_SCHEDULER.GET_AVAILABILITY, params));
                debugger
                promise.then((response) => {
                    if (response.status === 0) {
                        let data = response.data;
                        let companyScheduler = {
                            id: state.selectedAppointmentType.id,
                            name: state.selectedAppointmentType.eventType,
                            duration: state.selectedAppointmentType.duration,
                            durationType: state.selectedAppointmentType.durationType,
                            workflow_id: state.schedulerDetail.workflowId,
                            status_name: state.schedulerDetail.workflowStatus,
                            description: state.selectedAppointmentType.description,
                            fields: state.schedulerFields,
                            thank_you_msg: state.schedulerDetail.thankYouMsg,
                            submit_button_label: state.schedulerDetail.buttonLabel,
                            min_advance_notice: state.selectedTechnician.minAdvanceNotice,
                            min_advance_notice_type: state.selectedTechnician.minAdvanceNoticeType,
                            availableSlots: data.availableSlots,
                        }
                        if (state.selectedTechnician.minAdvanceNoticeType === 'days') {
                            selectedDateMoment.add(state.selectedTechnician.minAdvanceNotice, 'days');
                            dt.setDate(dt.getDate() + state.selectedTechnician.minAdvanceNotice);
                        }
                        let selectedDay = selectedDateMoment.day();

                        companyScheduler = {
                            ...companyScheduler,
                            'selectedDateMoment': selectedDateMoment,
                            'selectedDate': dt,
                            'selectedDay': selectedDay
                        }
                        const updatedState = {...state, selectedScheduler: companyScheduler, scheduler_booked_slots: data.bookedSlots};
                        setState(updatedState);
                    } else if (response.status === -1) {
                        setState({
                            ...state,
                            invalidUrl: true
                        });
                    }

                });
            } catch (error) {
                console.log(error);
            }
        }
    }

    let handleDateChange = (date) => {
        let selectedDateMoment = moment(date[0]);
        let selectedDay = selectedDateMoment.day();
        state.selectedScheduler = {
            ...state.selectedScheduler,
            selectedDay: selectedDay,
            selectedDate: date,
            selectedDateMoment: selectedDateMoment
        }
        setState({
            ...state,
        });
    }

    let handleTimeSlotClick = (datetime) => {
        let step = 2;
        if (isCompanyScheduler) {
            step = 3;
        }
        setState({ ...state, step, selected_date_time: datetime });
    }

    let updateParentState = (newState) => {
        if (newState.hasOwnProperty('bookingError') && !newState.bookingError) {
            loadSchedulerData(true);
        } else {
            setState({ ...state, ...newState });
        }
    }

    let changeScheduler = (event) => {

        let dt = new Date();
        let dateString = dt.getFullYear() + "/" + (dt.getMonth() + 1) + "/" + dt.getDate()
        let selectedDateMoment = moment(dateString);
        let selectedScheduler = state.allScheduler[event.target.value];
        selectedScheduler.selectedDateMoment = selectedDateMoment;

        setState({
            ...state,
            'selectedScheduler': selectedScheduler,
            step: 1,
            filledData: null
        });
    }

    if (state.invalidUrl) {
        return (<GenericNotFound msg={"Sorry, it doesn't look like this is a valid scheduling page."} />);
    }

    if (state.noAppointmentAvailable) {
        return (<GenericNotFound msg={"This link is not valid now. Sorry for the inconvenience."} />);
    }

    // const[mobilemenu,setMobilemenu] = useState(null);
    //                 const isMobileMenuOpen = Boolean(mobilemenu)

    //                 const openMobileMenu = (event)=>{
    //                     setMobilemenu(event.currentTarget)
    //                 }
    //                 const closeMobileMenu = ()=>{
    //                     setMobilemenu(null)
    //                 }
    return (
        <div className={'container ' + (isCompanyScheduler ? "company-container": '')}>
            { !isCompanyScheduler && <Header logo={state.logo} mounted={state.logoLoader}/>}
            <Body data={state}
                  handleDateChange={handleDateChange}
                  handleTimeSlotClick={handleTimeSlotClick}
                  saveSchedulerData={saveSchedulerData}
                  handleBack={handleBack}
                  updateParentState={updateParentState}
                  changeScheduler={changeScheduler}
                  isCompanyScheduler={isCompanyScheduler}
                  handleLocationChange={handleLocationChange}
                  handleAppointmentTypeChange={handleAppointmentTypeChange}
                  handleTechnicianChange={handleTechnicianChange}
                  onNextClick={onNextClick}
            />
            <Footer
                data={state.whiteLabel}
            />
        </div>
    );
}

class Header extends React.PureComponent {
    render() {
        return (
            <div className="header">
                <div className="logo">
                    {this.props.mounted ? <img src={this.props.logo} alt="Logo" style={{ paddingLeft: 0, float: 'left', maxWidth: 100, maxHeight: 60 }} /> : <SquareLoader
                        size={60}
                        color={"#87CEEB"}
                        loading={true}
                    />}
                </div>
            </div>
        );
    }
}


function Body(props) {
    const classes = useStyles();

    if (props.data.bookingError) {
        return (
            <div className="scheduler-body">
                <div className="scheduler-content" style={{ position: 'relative' }}>
                    <div className="booking-error">
                        <div style={{
                            fontWeight: 600,
                            fontSize: 16,
                            wordWrap: 'break-word',
                            lineHeight: 1.6,
                            marginBottom: 10,
                            color: 'black'
                        }}>An error occurred while booking.
                        </div>
                        <div style={{fontSize: 14, marginBottom: 20}}>This time slot was not an available option.</div>
                        <Button variant="contained"
                                onClick={props.updateParentState.bind(this, {bookingError: false, step: 1})}
                                style={{backgroundColor: '#EE5624', color: '#FFFFFF'}}>
                            Try Again
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    if (props.data.mounted) {
        if (isCompanyScheduler) {
            if (props.data.step === 1) {
                return (
                    <div className="scheduler-body company-scheduler-body">
                        <div className="company-scheduler-content">
                            <h3 style={{margin: "2rem 0 0.5rem", color: "#303030", fontSize: "1.65rem"}}>Welcome to our online appointment scheduler</h3>
                            <Header logo={props.data.logo} mounted={props.data.logoLoader}/>
                            <p style={{"margin": "1rem 0"}}>Please select a location to begin</p>
                            <FormControl variant="outlined" className={classes.selectControl}>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    onChange={props.handleLocationChange}
                                    value={props.data.selectedLocation}
                                    error={props.data.locationError}
                                    classes={{root: classes.selectControlSmall}}
                                >
                                    {
                                        props.data.locations
                                            .map(location => (
                                                    <MenuItem key={location}
                                                              value={location}>{location}
                                                    </MenuItem>
                                                )
                                            )
                                    }
                                </Select>
                            </FormControl>
                            {props.data.locationError && <p style={{marginBottom: "5px", color: "red"}}>Select a location to proceed</p>}
                            <div style={{"margin": "1rem 0"}}>
                                <Button variant="contained" color="primary"
                                        onClick={props.onNextClick}>Continue</Button>
                            </div>
                        </div>
                    </div>
                );
            } else if (props.data.step === 2 || props.data.step === 3 || props.data.step === 4) {
                let date = new Date();

                if (props.data.selectedScheduler.min_advance_notice_type !== null && props.data.selectedScheduler.min_advance_notice_type === 'days') {
                    date.setDate(date.getDate() + props.data.selectedScheduler.min_advance_notice);
                }
                let mindate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

                let flatPickerConfig = {
                    inline: true,
                    minDate: mindate,
                    disableMobile: "true"
                }
                // let backButtonStyle = { backgroundColor: '#5a6268' };
                return (
                    <div className="scheduler-body company-scheduler-body">
                        <div className="scheduler-content">
                            <div className="company-scheduler-content-header">
                                <FormControl variant="outlined" className={classes.selectControl} style={{marginTop: "1rem"}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Appointment Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        onChange={props.handleAppointmentTypeChange}
                                        value={props.data.selectedAppointmentType}
                                        label="Appointment Type"
                                        disabled={props.data.step === 3 || props.data.step === 4}
                                        classes={{root: classes.selectControlSmall}}
                                    >
                                        {
                                            props.data.appointmentTypes
                                                .map(type => (
                                                        <MenuItem
                                                            key={type.id}
                                                            value={type}
                                                        >
                                                            {type.eventType} ({type.duration} {type.durationType})
                                                        </MenuItem>
                                                    )
                                                )
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" className={classes.selectControl} style={{marginTop: "1rem"}}>
                                    <InputLabel id="demo-simple-select-outlined-label">Technician</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        onChange={props.handleTechnicianChange}
                                        value={props.data.selectedTechnician}
                                        label="Technician"
                                        disabled={props.data.step === 3 || props.data.step === 4}
                                        classes={{root: classes.selectControlSmall}}
                                    >
                                        {
                                            props.data.technicians
                                                .map(technician => (
                                                        <MenuItem
                                                            key={technician.id}
                                                            value={technician}
                                                        >
                                                            {technician.name}
                                                        </MenuItem>
                                                    )
                                                )
                                        }
                                    </Select>
                                </FormControl>
                                { props.data.step === 2 && <Button variant="outlined"
                                         onClick={() => props.handleBack(null)}
                                         disabled={props.savingForm}
                                         style={{
                                             marginTop: "1rem",
                                             position: "absolute",
                                             right: 0,
                                             bottom: "101%"
                                         }}>
                                    <ArrowBack/> Back
                                </Button>}
                            </div>

                            {
                                props.data.step === 2 && (
                                    <div>
                                        <div className="step1-body">
                                            <div className="body-wrapper">
                                                <div className="datepicker-div"
                                                     key={props.data.selectedScheduler.selectedDate}>
                                                    <Flatpickr
                                                        value={props.data.selectedScheduler.selectedDate}
                                                        options={flatPickerConfig}
                                                        onChange={props.handleDateChange}
                                                    />
                                                    <div className="time-zone">{timezone}</div>
                                                </div>
                                                <div className="time-slot">
                                                    <div className="h-2" style={{
                                                        marginBottom: 15,
                                                        textAlign: 'center'
                                                    }}>{props.data.selectedScheduler.selectedDateMoment.format('MMMM D, YYYY')}</div>
                                                    <TimeSlots bookedSlots={props.data.scheduler_booked_slots}
                                                               data={props.data.selectedScheduler}
                                                               handleTimeSlotClick={props.handleTimeSlotClick}/>
                                                </div>
                                                <div style={{clear: 'both'}}/>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                (props.data.step === 3 || props.data.step === 4) && <div className="step2-body">
                                    <div className="left-section">
                                        <ScheduledTime time={props.data.selected_date_time}/>
                                    </div>
                                    <div className="right-section">
                                        {props.data.step === 3 &&
                                        <SchedulerForm data={props.data.selectedScheduler}
                                                       saveSchedulerData={props.saveSchedulerData}
                                                       handleBack={props.handleBack}
                                                       updateParentState={props.updateParentState}
                                                       savingForm={props.data.savingForm}
                                                       filledData={props.data.filledData}
                                        />
                                        }
                                        {props.data.step === 4 &&
                                        <ThanksMsg msg={props.data.selectedScheduler.thank_you_msg}/>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                )
            }

        } else {
            let date = new Date();

            let schedulersLength = Object.keys(props.data.allScheduler).length;

            if (!!props.data.selectedScheduler.min_advance_notice_type && props.data.selectedScheduler.min_advance_notice_type === 'days') {
                date.setDate(date.getDate() + props.data.selectedScheduler.min_advance_notice);
            }
            let minDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

            let flatPickerConfig = {
                inline: true,
                minDate: minDate,
                disableMobile: "true"
            }
            let headerHeight = props.data.selectedScheduler.location === '' ? '60px' : '70px';

            let schedulerOptions = Object.keys(props.data.allScheduler).map((schedulerKey) => {
                let scheduler = props.data.allScheduler[schedulerKey];
                let durationType = null;
                if (scheduler.durationType === 'min') {
                    durationType = 'minutes'
                } else if (scheduler.durationType === 'hr' || scheduler.durationType === 'hour') {
                    durationType = scheduler.duration > 1 ? 'hours' : 'hour';
                }
                let schedulerInfo = '';
                if (scheduler.location === '') {
                    schedulerInfo = scheduler.duration + ' ' + durationType;
                } else {
                    schedulerInfo = scheduler.duration + ' ' + durationType + '. ' + scheduler.location + '.';
                }
                let desktopLocation = scheduler.location !== '' ? ' | ' + scheduler.location : '';
                return (
                    <div style={{padding: 0, margin: 0, textAlign: 'left'}} key={scheduler.id}>
                        <FormControlLabel
                            value={schedulerKey}
                            control={<StyledRadio/>}
                            label={<span className="radio-label" title={scheduler.name}>{scheduler.name}</span>}
                        />
                        <div className="time-section-desktop" style={{
                            fontSize: 12,
                            margin: 0,
                            padding: 0,
                            paddingLeft: 20,
                            paddingBottom: 3,
                            textAlign: 'left'
                        }}>
                            {'(' + scheduler.duration + ' ' + durationType + ')'} {desktopLocation}
                        </div>
                        <div className="time-section" style={{
                            fontSize: 12,
                            margin: 0,
                            padding: 0,
                            paddingLeft: 20,
                            paddingBottom: 3,
                            textAlign: 'left'
                        }}>
                            <i className="fa fa-clock-o" aria-hidden="true" style={{
                                margin: 0,
                                padding: 0,
                                paddingLeft: '3px',
                                fontSize: '15px',
                                marginRight: '5px'
                            }}/>
                            {schedulerInfo}
                        </div>
                    </div>
                )
            });
            return (
                <div className="scheduler-body">
                    <div className="scheduler-content">
                        <div>
                            {schedulersLength === 1 ?
                                <div>
                                    <div className="step1-header desktop-single" style={{height: headerHeight}}>
                                        <div className="step1-header-desktop">
                                            <div className="h-1">{props.data.selectedScheduler.name}</div>
                                            <Duration device='desktop' show={true}
                                                      duration={props.data.selectedScheduler.duration}
                                                      durationType={props.data.selectedScheduler.durationType}/>
                                            {props.data.selectedScheduler.location !== '' && <div className="location"
                                                                                                 style={{fontSize: 12}}>{' | ' + props.data.selectedScheduler.location}</div>}
                                        </div>
                                    </div>
                                    <div className="step1-header mobile-single" style={{height: headerHeight}}>
                                        <div className="step1-header-mobile">
                                            <div className="h-1">{props.data.selectedScheduler.name}</div>
                                            <Duration device='mobile' show={true}
                                                      duration={props.data.selectedScheduler.duration}
                                                      durationType={props.data.selectedScheduler.durationType}/>
                                            {props.data.selectedScheduler.location !== '' &&
                                            <div style={{fontSize: 12}}>{props.data.selectedScheduler.location}</div>}
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>
                                    <div className="step1-header2 desktop-header2">
                                        <div className="radio-buttons header-desktop-version">
                                            <FormControl component="fieldset">
                                                <RadioGroup onChange={props.changeScheduler}
                                                            defaultValue={props.data.selectedSchedulerKey}
                                                            name="scheduler-options">
                                                    {schedulerOptions}
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="step1-header2">
                                        <div className="radio-buttons header-mobile-version">
                                            <FormControl component="fieldset">
                                                <RadioGroup onChange={props.changeScheduler}
                                                            defaultValue={props.data.selectedSchedulerKey}
                                                            name="scheduler-options">
                                                    {schedulerOptions}
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>
                            }
                            {props.data.step === 1 && <div className="step1-body">
                                <div className="body-wrapper">
                                    <div className="datepicker-div" key={props.data.selectedScheduler.selectedDate}>
                                        <Flatpickr
                                            value={props.data.selectedScheduler.selectedDate}
                                            options={flatPickerConfig}
                                            onChange={props.handleDateChange}
                                        />
                                        <div className="time-zone">{timezone}</div>
                                    </div>
                                    <div className="time-slot">
                                        <div className="h-2" style={{
                                            marginBottom: 15,
                                            textAlign: 'center'
                                        }}>{props.data.selectedScheduler.selectedDateMoment.format('MMMM D, YYYY')}</div>
                                        <TimeSlots bookedSlots={props.data.scheduler_booked_slots}
                                                   data={props.data.selectedScheduler}
                                                   handleTimeSlotClick={props.handleTimeSlotClick}/>
                                    </div>
                                    <div style={{clear: 'both'}}/>
                                </div>
                            </div>
                            }
                            {(props.data.step === 2 || props.data.step === 3) && <div className="step2-body">
                                <div className="left-section">
                                    <ScheduledTime time={props.data.selected_date_time}/>
                                </div>
                                <div className="right-section">
                                    {props.data.step === 2 &&
                                    <SchedulerForm data={props.data.selectedScheduler}
                                                   saveSchedulerData={props.saveSchedulerData}
                                                   handleBack={props.handleBack}
                                                   updateParentState={props.updateParentState}
                                                   savingForm={props.data.savingForm}
                                                   filledData={props.data.filledData}
                                    />
                                    }
                                    {props.data.step === 3 &&
                                    <ThanksMsg msg={props.data.selectedScheduler.thank_you_msg}/>
                                    }
                                </div>
                            </div>
                            }

                        </div>
                    </div>
                </div>
            );
        }
    } else {
        return (
            <div className="scheduler-body">

                <div className="loader-div">
                    <BeatLoader
                        size={15}
                        color={"#0BB5FF"}
                        loading={true}
                    />
                </div>
            </div>
        );
    }
}

function Footer(props) {
    return (<div className="footer">
        {!props.data && <div><span>Powered By </span><a target="_blank" rel="noopener noreferrer" href="http://www.soffront.com/" style={{ textDecoration: 'none' }}><span className="sf-1">SOF</span><span className="sf-2">FRONT</span></a></div>}
    </div>);
}

function ScheduledTime(props) {
    let scheduledDateTime = moment(props.time);
    let scheduledDate = scheduledDateTime.format('dddd, MMMM DD, YYYY');
    let scheduledTime = scheduledDateTime.format('h:mm A');
    return (
        <div style={{ fontSize: 14, fontWeight: 'normal', lineHeight: 1.6 }}>
            <div>Selected Time:</div>
            <div>{scheduledDate}</div>
            <div>{scheduledTime + " " + timezone} </div>
        </div>
    );
}

function Description(props) {
    return (
        <div style={{ marginTop: 30, maxHeight: 300, overflow: 'auto', fontSize: 14, textAlign: 'justify', lineHeight: 1.6 }}>
            {props.description}
        </div>);
}

function TimeSlots(props) {
    let validTimeSlot = () => { //debugger
        const now = moment();
        const selectedDateStrig = props.data.selectedDateMoment.format('YYYY-MM-DD HH:mm:ss');
        const currentSlot = moment(selectedDateStrig);
        if (props.data.min_advance_notice_type === 'hours') {
            now.add(props.data.min_advance_notice, 'hours');
        } else if (props.data.min_advance_notice_type === 'days') {
            now.add(props.data.min_advance_notice, 'days');
        }
        const currentSlotColne = moment(selectedDateStrig);
        const currentSlotEnd = currentSlotColne.add(props.data.duration, 'minutes');
        let bookedSlotMomentStart = null;
        let bookedSlotMomentEnd = null;
        if (currentSlot.diff(now) <= 0) {
            return false;
        } else {
            let bookedSlots = props.bookedSlots.filter((el) => {
                let keys = Object.keys(el);
                let key = keys[0];
                return key === props.data.selectedDateMoment.format('YYYY-MM-DD');
            });
            for (let i = 0; i < bookedSlots.length; i++) {
                let bookedDateTimeObj = bookedSlots[i];
                let keys = Object.keys(bookedDateTimeObj);
                let key = keys[0];
                let currentObj = bookedDateTimeObj[key];
                let date = key;
                let start_time = currentObj.str_time;
                let end_time = currentObj.end_time;
                bookedSlotMomentStart = moment(date + ' ' + start_time);
                bookedSlotMomentEnd = moment(date + ' ' + end_time);
                if (currentSlot <= bookedSlotMomentStart && currentSlotEnd >= bookedSlotMomentEnd) {
                    return false;
                } else if (currentSlot >= bookedSlotMomentStart && currentSlot < bookedSlotMomentEnd) {
                    return false;
                }
                else if (bookedSlotMomentStart < currentSlotEnd && bookedSlotMomentEnd > currentSlotEnd) {
                    return false;
                }
            }
        }
        bookedSlotMomentStart = null;
        bookedSlotMomentEnd = null;
        return true;
    }
    let getTimeSlots = () => {
        let data = props.data;
        let selectedDay = data.selectedDay;
        if (selectedDay === 0) {
            selectedDay = 7;
        }

        let dt = new Date();
        let dateString = dt.getFullYear() + "/" + (dt.getMonth() + 1) + "/" + dt.getDate()
        let momentToday = moment(dateString);
        let today_no = momentToday.day();

        let availableTimeObjList = data.availableSlots.filter(function (el) {
            return el.day_id === selectedDay;
        });

        let tillNextDay = false;
        if (availableTimeObjList != null && availableTimeObjList.length >= 1) {
            if (availableTimeObjList.length === 2) {
                if (availableTimeObjList[1].from_time === '00:00') {
                    let temp = availableTimeObjList[1];
                    availableTimeObjList[1] = availableTimeObjList[0];
                    availableTimeObjList[0] = temp;
                } else if (availableTimeObjList[1].to_time === '24:00') {
                    tillNextDay = true;
                }
            }
            let timeSlots = [];
            availableTimeObjList.forEach(function (availableTimeObj) {
                let startTime = moment(availableTimeObj.from_time, "hh:mm");
                let endTime = moment(availableTimeObj.to_time, "hh:mm");
                let duration = moment.duration(endTime.diff(startTime));
                let time_duration = duration.asMinutes();
                let from_time = availableTimeObj.from_time;
                let schedulerDuration = null;
                if (data.durationType === 'hr' || data.durationType === 'hour') {
                    schedulerDuration = data.duration * 60;
                } else {
                    schedulerDuration = data.duration;
                }
                if (time_duration >= schedulerDuration) {
                    let max_length = Math.floor(time_duration / schedulerDuration);
                    let selectedDateMoment = data.selectedDateMoment;
                    selectedDateMoment.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

                    let form_time_split = from_time.split(':');
                    selectedDateMoment.add(form_time_split[0], 'hours');
                    selectedDateMoment.add(form_time_split[1], 'minutes');

                    if (validTimeSlot()) {
                        timeSlots.push(selectedDateMoment.clone());
                    }

                    if (availableTimeObj.to_time === '24:00' && tillNextDay) {
                        max_length = max_length - 1;
                    } else {
                        max_length = max_length - 1
                    }
                    for (let i = 0; i < max_length; i++) {
                        if (data.durationType === 'hr' || data.durationType === 'hour') {
                            selectedDateMoment.add(data.duration, 'hours');
                        } else {
                            selectedDateMoment.add(data.duration, 'minutes');
                        }

                        if (!validTimeSlot()) {
                            continue;
                        }
                        timeSlots.push(selectedDateMoment.clone());
                    }
                }
            });
            if (timeSlots.length > 0) {
                return timeSlots.map((date, index) => {
                    return (<div className="slot" key={index}><button onClick={props.handleTimeSlotClick.bind(this, date.format("YYYY-MM-DD HH:mm:ss"))} className="slot-btn" value={date.format("YYYY-MM-DD HH:mm:ss")}>{date.format('hh:mm A')}</button></div>)
                });
            } else if (selectedDay === today_no) {
                return <div style={{ lineSpacing: 1.6, fontSize: 14, textAlign: 'center' }}>There are no available slots for today</div>
            } else {
                return <div style={{ lineSpacing: 1.6, fontSize: 14, textAlign: 'center' }}>There are no available slots for {props.data.selectedDateMoment.format('dddd')}</div>
            }
        } else {
            return <div style={{ lineSpacing: 1.6, fontSize: 14, textAlign: 'center' }}>There are no available slots for {props.data.selectedDateMoment.format('dddd')}</div>
        }
    }

    let timeSlots = getTimeSlots();
    return (
        <div className="time-slots">{timeSlots}</div>
    );
}

function Duration(props) {
    if (props.show) {
        let durationType = null;
        if (props.durationType === 'min') {
            durationType = 'minutes'
        } else if (props.durationType === 'hr' || props.durationType === 'hour') {
            durationType = props.duration > 1 ? 'hours' : 'hour';
        }
        if (props.device === 'desktop') {
            return <span style={{ fontSize: 12 }}> ({props.duration} {durationType}) </span>
        }
        return (
            <div style={{ marginTop: 0 }} className="duration-div" >
                <i className="fa fa-clock-o" aria-hidden="true" style={{ marginTop: '3px', fontSize: '15px', marginRight: '5px' }}/>
                <span style={{ fontSize: 14 }}>{props.duration} {durationType}</span>
            </div>
        );
    } else {
        return null;
    }
}

function SchedulerForm(props) {
    const classes = useStyles();
    let stateFields = {};
    if (props.filledData != null) {
        stateFields = props.filledData;
    } else {
        props.data.fields.forEach(field => {
            stateFields[field.field_name] = {
                value: '',
                error: false,
                required: field.required === 1,
                field_name: field.field_name,
                field_type: field.field_type,
                errorText: '',
                field_label: field.field_label,
                list_values: Array.isArray(field.list_values) ? field.list_values : []
            };
        });
    }
    const [state, setState] = useState({ fields: stateFields, field_names: [] });
 
    useEffect(() => {
        if (!state.fields.hasOwnProperty('country')) {
            fetchStateList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let setFieldValue = (fieldName, event) => {
        const fieldValue = event.target.value;
        state.fields[fieldName].value = fieldValue;
        state.fields[fieldName].error = false;
        state.fields[fieldName].errorText = '';
        setState({ ...state });
        if (fieldName === "country" && !!fieldValue && fieldValue !== '') {
            fetchStateList(fieldValue)
        }
    }

    function fetchStateList(country, currentState) {
        debugger
        const tempState = currentState || state;
        if(tempState.fields.hasOwnProperty('state')) {
            const params = {
                object: "accounts",
                name: "state",
                value: country || '',
                list_type: "external",
                project_id: projectId,
                user_id: userId,
            }
            let promise = Promise.resolve(get(endPoints.SCHEDULER.GET_STATES, params));
            promise.then((response) => {
                if (response.status === 0) {
                    tempState.fields['state'].list_values = response.data;
                    setState({ ...tempState });
                }
            });
        }
    }
    let getFields = () => {
        return Object.keys(state.fields).map(key => {
            const field = state.fields[key];
            let required = '';
            if (field.required) {
                required = ' (required)';
            }
            if (field.field_type === 201) {
                return (
                    <div key={field.field_name + field.field_label + field.field_type}>
                        <TextField
                            fullWidth
                            error={state.fields[field.field_name].error}
                            label={field.field_label + required}
                            value={state.fields[field.field_name].value}
                            helperText={state.fields[field.field_name].errorText}
                            onChange={setFieldValue.bind(this, field.field_name)}
                            className="custom-textfield"
                            InputLabelProps={{
                                style: {
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    width: '100%',
                                    textAlign: 'left'
                                    //color: 'green'
                                },
                                title: field.field_label + required
                            }}
                        />
                    </div>
                );
            } else if (field.field_type === 205) {
                return (<div style={{marginTop: 10}} key={field.field_name + field.field_label + field.field_type}>
                    <TextField
                        id="outlined-multiline-flexible"
                        label={field.field_label + required}
                        multiline
                        rows="6"
                        error={state.fields[field.field_name].error}
                        value={state.fields[field.field_name].value}
                        onChange={setFieldValue.bind(this, field.field_name)}
                        className="custom-textfield"
                        variant="outlined"
                    />
                </div>);
            } else if (field.field_type === 207) {
                const { list_values: listValues } = field;
                let availableMenuItem = Array.isArray(listValues) ? listValues : [];
                availableMenuItem = availableMenuItem.filter(f => { return f.value !== '' });
                let menuList = availableMenuItem.map((fld, i) => (<MenuItem key={fld.id + "_" + i} value={fld.id}>{fld.value}</MenuItem>));

                return (<div style={{marginTop: 5}} key={field.field_name + field.field_label + field.field_type}>
                    <FormControl className={classes.formControl} error={state.fields[field.field_name].error}>
                        <InputLabel id="simple-select-label">{field.field_label + required}</InputLabel>
                        <Select
                            labelId="simple-select-label"
                            id="simple-select"
                            value={state.fields[field.field_name].value}
                            onChange={setFieldValue.bind(this, field.field_name)}
                            style={{ textAlign: 'left' }}
                        >
                            {menuList}
                        </Select>
                    </FormControl>
                </div>);
            }
            return null;
        });
    }

    let validateForm = () => {
        let isValid = true;
        for (let field in state.fields) {
            if ((state.fields[field].field_type === 201 || state.fields[field].field_type === 205 || state.fields[field].field_type === 207) && state.fields[field].required === true && state.fields[field].value.trim() === '') {
                state.fields[field].error = true;
                // state.fields[field].errorText = "required field";
                isValid = false;
            } else if (state.fields[field].field_type === 201 && state.fields[field].field_name === 'email' && !isEmail(state.fields[field].value)) {
                state.fields[field].error = true;
                state.fields[field].errorText = 'Invalid Email';
                isValid = false;
            }
        }
        setState({ ...state });
        return isValid;
    }

    let handleSubmitForm = (timeSlot) => {
        if (validateForm()) {
            let now = moment();
            let timeSlotMoment = moment(timeSlot);
            if (timeSlotMoment.diff(now) < 0) {
                props.updateParentState({ bookingError: true });
                return false;
            }
            let fields = {};
            for (let [key, val] of Object.entries(state.fields)) {
                state.field_names.push({ name: key, label: val.field_label });
                fields[key] = val.value;
            }
            props.saveSchedulerData(fields, state.field_names);
        }
    }

    let handleBack = () => {
        props.handleBack(state.fields);
    }

    let fields = getFields();
    let saveButtonStyle = { marginLeft: 10, backgroundColor: '#EE5624', color: '#FFFFFF' };
    let backButtonStyle = { backgroundColor: '#5A6268' };
    if (props.data.savingForm) {
        saveButtonStyle = { ...saveButtonStyle, backgroundColor: '#F8B6A0' };
        backButtonStyle = { backgroundColor: '#A0A7AC' };
    }

    return (
        <div style={{ width: '98%', }}>
            <div className="form-heading">Enter Your Details</div>
            <div className="form-container">
                <form className={classes.root} noValidate autoComplete="off">
                    {fields}
                </form>

            </div>
            <div className="buttons-container">
                <div style={{ display: 'inline', float: 'left' }} className="buttons back">
                    <Button variant="contained" color="secondary" onClick={handleBack} disabled={props.savingForm} style={backButtonStyle}>
                        Back
                    </Button>
                </div>
                <div style={{ display: 'inline', float: 'left' }} className="buttons submit">
                    <Button
                        variant="contained"
                        onClick={() => handleSubmitForm(props.data.selected_date_time)}
                        disabled={props.data.savingForm || !fields || fields.length === 0}
                        style={saveButtonStyle}>
                        {props.data.submit_button_label || "Save"}
                    </Button>
                </div>
                {props.savingForm && <div style={{ display: 'inline-block', float: 'left', marginTop: 8 }} className="submit-loader"><ScaleLoader
                    height={15}
                    width={4}
                    radius={2}
                    margin={2}
                    color={"#0BB5FF"}
                    loading={true}
                /></div>
                }
            </div>
        </div>
    );
}

function ThanksMsg(props) {
    return (
        <div className="thanks-msg">
            <div style={{ fontSize: 20, marginBottom: 20 }}>Thank You</div>
            <div>{props.msg}</div>
        </div>
    );
}

function isEmail(email) {
    let regExp = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,})+$/;
    let result = email.search(regExp);
    return !(result === -1);
}

export default Scheduler;